
import objectPath from 'object-path'

const getters = {
  isLoading: state => state.isLoading,
  isLoadingMore: state => state.isLoadingMore,
  isUpdating: state => state.isUpdating,
  isFiltersLoaded: state => state.isFiltersLoaded,
  isFiltersApplied: state => state.isFiltersApplied,
  isFiltersDisabled: state => state.isFiltersDisabled,
  isFavoriteLoading: state => state.isFavoriteLoading,
  getErrors: state => ({
    searchFailed: state.searchFailed,
    errorsList: state.errors
  }),
  getCollection: state => state.collection,
  getField: state => target => objectPath.get(state, target),
  getCollectionFilters: state => state.collectionFilters,
  getMinPrices: state => state.minPrices,
  getViewType: state => state.viewType,
  isEmptySearchResult: state => state.isEmptySearchResult,
  showAgencyPrice: state => state.agencyPrice,
  getFormForSearch: (state) => {
    const {
      placeId,
      placeType,
      checkInDate,
      duration,
      rooms,
      hotelSearchId,
      hasMore,
      currency,
      priceSort
    } = state.form

    return {
      placeId,
      placeType,
      checkInDate,
      duration,
      rooms,
      hotelSearchId,
      hasMore,
      currency,
      priceSort,
      filters: state.filters
    }
  },
  getForm: state => ({
    ...state.form,
    filters: state.filters
  }),
  showForm: state => state.showForm,
  showSearch: state => state.showSearch,
  getPagination: state => state.pagination
}

export default getters